export const REDIRECT_OPTIONS = [301, 302]
export const ANNUAL_INCOME_OPTIONS = ['0 - 0.5', '0.5 - 1', '1 - 5', '5 - 10', '10 - 25', '25 - 50', '50 - 150']
